import type {FlexSuiteHeroProps} from './types'
import {FlexSuiteHeroDefault} from './FlexSuiteHeroDefault'
import {FlexSuiteHeroStacked} from './FlexSuiteHeroStacked'
import {FlexSuiteHeroCarousel} from './FlexSuiteHeroCarousel'

export function FlexSuiteHero(props: FlexSuiteHeroProps) {
  const {heroVariant} = props

  switch (heroVariant) {
    case 'Stacked':
      return <FlexSuiteHeroStacked fields={props} />
    case 'Carousel':
      return <FlexSuiteHeroCarousel fields={props} />
    default:
      return <FlexSuiteHeroDefault fields={props} />
  }
}
